import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import Block from "./Block";
import { round } from "lodash";

const Graph = ({ module }) => {
  const { graphData } = module;
  const [mergedOptions, setMergedOptions] = useState(null);

  useEffect(() => {
    if (graphData) {
      let data = graphData.sort((a, b) => (a.TotalExpectation > b.TotalExpectation ? 1 : -1));
      let labels = data.map((item) => {
        if (item.Name === "Sørøst-Norge") {
          return {
            value: item.Name,
            textStyle: { fontWeight: "bolder", color: "black", fontSize: "15" },
          };
        }
        return { value: item.Name };
      });

      let seriesData = {
        type: "bar",
        barGap: 0,
        data: data.map((item) => {
          return { name: item.Name, value: item.TotalExpectation };
        }),
        label: {
          show: true,
          rotate: 0,
          formatter: function (params) {
            return `${params.value.toLocaleString("nb-NO")}`;
          },
        },
        emphasis: {
          focus: "series",
        },
      };
      let nObj = {
        ...JSON.parse(options),
        tooltip: {
          trigger: "axis",
          order: "valueDesc",
          formatter: function (params) {
            let tooltip = `${params[0].axisValue} <br/>`;
            params.forEach((item) => {
              tooltip += `${item.marker} ${round(item.value, 2).toLocaleString("nb-NO")} </br>`;
            });
            return tooltip;
          },
        },

        yAxis: {
          type: "category",
          data: labels,
          axisLabel: {
            interval: 0,
            rotate: 0, //If the label names are too long you can manage this by rotating the label.
          },
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return value;
            },
          },
        },
        series: seriesData,
      };

      setMergedOptions(nObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [graphData]);

  if (mergedOptions) {
    return <ReactECharts option={mergedOptions} style={{ marginTop: "20px", height: "600px" }} notMerge={true} />;
  }

  return null;
};
export default Graph;

const options = JSON.stringify({
  grid: { top: 10, right: 45, bottom: 2, left: 40, containLabel: true },
  // xAxis: {
  //   type: 'category',
  //   data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  // },
  yAxis: {
    type: "value",
  },
  series: null,
  tooltip: {
    trigger: "item",
    formatter: `{c}%`,
  },
});

// const parseOptions = (options) => {
//   return options.map((option) => Object.assign({}, { label: option.name, value: option.areaId }));
// };
